import React, { useState, useMemo } from "react";
import './styles/index'
import { CURRENT_CART_VERSION } from '../ShoppingCart/constants';
import { ICartItems, ITicket, ITWPTicketOrderItem } from '../ShoppingCart/types';
import { retrieveCartItems, storeCartItems } from '../ShoppingCart/helpers';
import t from "./helpers"
import {Field, Select, Button, Input} from "./common";

const formattedMinDateString = (date) => {
  let [y, m, d] = date.toLocaleDateString('ja-JP').split('/')
  m = m.padStart(2, '0')
  d = d.padStart(2, '0')
  return `${y}-${m}-${d}`
}

const syncCart = () => {
  return new Promise<void>((resolve) => {
    setTimeout(() => { resolve(); }, 1000);
  });
};

export const TWP = ({ticket}: {ticket: ITicket}) => {
  const [isLoading, setIsLoading] = useState(false)
  const url = new URL(window.location.href);

  const [values, setValues] = useState({
    plan: ticket.plans[0], // planIdではなく、planを使う理由は、planの方が汎用性が高いこと（planId以外のplan関連情報も取得できるため）
    pickupPlaceId: ticket.pickupPlaces[0].pickupPlaceId,
    adultQuantity: 1,
    useStartDate: ''
  })

  const agreedTotalAmount = useMemo(() => {
    return values.adultQuantity * values.plan.adultSellingPrice
  }, [values.adultQuantity, values.plan.adultSellingPrice])

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    setValues(prev => {
      if (event.target.name === 'plan') {
        return {
          ...prev,
          [event.target.name]: ticket.plans.find(p => p.planId === parseInt(event.target.value))
        }
      } else if (event.target.name === 'useStartDate') {
        return {
          ...prev,
          [event.target.name]: event.target.value
        }
      } else {
        return {
          ...prev,
          [event.target.name]: parseInt(event.target.value)
        }
      }
    })
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (isLoading) return
    setIsLoading(true)
    const prevCartItems: ICartItems = retrieveCartItems(CURRENT_CART_VERSION);

    const ticketOrderItem: ITWPTicketOrderItem = {
      ticketId: ticket.ticketId,
      planId: values.plan.planId,
      pickupPlaceId: values.pickupPlaceId,
      adultQuantity: values.adultQuantity,
      useStartDate: values.useStartDate,
      agreedTotalAmount,
      ticket
    }

    const cartItems = { ...prevCartItems, twpTicketOrderItems: [...(prevCartItems.twpTicketOrderItems || []), ticketOrderItem] };

    await syncCart();
    storeCartItems(cartItems)
    setIsLoading(false)
  }
  return (
    <form onSubmit={handleSubmit} noValidate>
      {/* plans */}
      <div className="price-calculator__section">
        <Field htmlFor='plan' label={t.price()}>
          <Select id='plan' name='plan' options={
            ticket.plans.map(({ planId, name, adultSellingPrice }) => ({ id: planId, value: planId, label: `${name} | JPY ${adultSellingPrice}` }))
          } value={values.plan.planId} onChange={handleChange} />
        </Field>
      </div>
      {/* pickup places */}
      <div className="price-calculator__section">
        <Field htmlFor='pickupPlaceId' label={t.pickupPlace()}>
          <Select id='pickupPlaceId' name='pickupPlaceId' options={
            ticket.pickupPlaces.map(({pickupPlaceId, name}) => ({id: pickupPlaceId, value: pickupPlaceId, label: name}))
          } value={values.pickupPlaceId} onChange={handleChange} />
        </Field>
      </div>
      {/* number of adults */}
      <div className="price-calculator__section">
        <Field htmlFor='adultQuantity' label={t.numPassengers()}>
          <Select id='adultQuantity' name='adultQuantity' options={
            Array(10).fill(0).map((_, i) => ({id: i, value: i + 1, label: i + 1}))
          } value={values.adultQuantity} onChange={handleChange} />
        </Field>
      </div>
      {/* use start date */}
      <div className="price-calculator__section">
        <Field htmlFor='useStartDate' label={t.useStartDate()}>
          <Input id='useStartDate' name='useStartDate' type='date' min={formattedMinDateString(new Date())} value={values.useStartDate} onChange={handleChange} />
        </Field>
      </div>
      {/* add-to-cart button */}
      <div className="price-calculator__cta">
        {/* snow-cart-button = gtmのカートインイベント用のクラス　*/}
        {/* TODO: クラス以外の方法でトリガーする */}
        <Button type="submit" className="snow-cart-button">
          {t.addToCart()}
        </Button>
      </div>
    </form>
  )
}
